import { BACKEND_URL } from "../../views/common/utils/constants";
import { getQueryStrings } from "../../views/common/utils/helpers";
import {
  IAPIResponse,
  IFilterFetch,
} from "../../views/common/utils/interfaces";
import { errorToastify, successToastify } from "../../views/common/utils/Toasty";
import { CustomAxios } from "../customAxios";

export const getAdminBuyerTransactions = async (filter?: IFilterFetch) => {
  try {
    const { searchQuery, filterQuery } = getQueryStrings(filter);

    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/admin/transactions?${searchQuery}${filterQuery}`
    );

    if (!result.status) {
      throw new Error(result.message);
    }
    return result;
  } catch (error) {
    if (typeof error === "string") {
      // errorToastify(error);
    }
  }
};

export const approvePaymentTransaction = async (action: "approve" | "reject", id: string) => {
  const bodyData: any = {}
  bodyData.action = action
  const toastMsg = action === "approve" ? "Payment approved successfully" : "Payment rejected successfully"
  if(action === "reject"){
    bodyData['rejection_reason'] = "Incomplete documents"
  }
  try {
    const { data: result }: IAPIResponse = await CustomAxios().post(`${BACKEND_URL}/admin/transactions/${id}/change-status`, {
      ...bodyData
    })
    successToastify(toastMsg)
  } catch (error) {
     if (typeof error === "string") {
      errorToastify(error);
    }
  }
}